import React from 'react';
import { motion } from 'framer-motion';
import type { PeerOption } from '../../types/pulse';
interface DistributionBarsProps {
  options: PeerOption[];
  accent: string;
  highlightId?: string | null;
  delay?: number;
}
export function DistributionBars({
  options,
  accent,
  highlightId,
  delay = 0
}: DistributionBarsProps) {
  const sorted = [...options].sort((a, b) => b.peerPercent - a.peerPercent);
  const emphasised = highlightId ?? sorted[0]?.id;
  return <ul className="space-y-3.5" data-id="element-536" data-mp="pq0opsjr2c6y">
      {sorted.map((o, i) => {
      const strong = o.id === emphasised;
      return <li key={o.id} data-id="element-537" data-mp="fu72fhg8b4bz" data-mpi={i}>
            <div className="flex items-baseline justify-between gap-3 text-[13px]" data-id="element-538" data-mp="fsvz1iqp3yle">
              <span className={strong ? 'font-medium text-navy-900' : 'text-slate-500'} data-id="element-539" data-mp="krpcjb5zfplk">
                {o.label}
                {highlightId && strong && <span className="ml-2 rounded-full px-1.5 py-0.5 text-[9px] font-semibold uppercase tracking-wider text-white" style={{
              backgroundColor: accent
            }} data-id="element-540" data-mp="35izn3h4ql0dp">
                    You
                  </span>}
              </span>
              <span className="font-semibold tabular-nums" style={{
            color: strong ? accent : '#64748B'
          }} data-id="element-541" data-mp="315je2m3nzj4a">
                {o.peerPercent}%
              </span>
            </div>
            <div className="mt-1.5 h-2 w-full overflow-hidden rounded-full bg-mist-200" data-id="element-542" data-mp="2w92mfhx9ammg">
              <motion.div className="h-full rounded-full" style={{
            backgroundColor: strong ? accent : '#B6C4D3'
          }} initial={{
            width: 0
          }} animate={{
            width: `${o.peerPercent}%`
          }} transition={{
            duration: 1,
            delay: delay + i * 0.08,
            ease: [0.22, 1, 0.36, 1]
          }} data-id="element-543" data-mp="3a4eh5pbewd3d" />
            </div>
          </li>;
    })}
    </ul>;
}